export default __webpack_public_path__ + "static/media/uefa.f0e8f910.jpg";